export const validateMaskedPhone = (value) => /\+7 \d{3} \d{3} \d{2} \d{2}/.test(value);

export const maskedPhone = (value) => ({
  status: validateMaskedPhone(value) ? 'ok' : 'fail',
  msg: 'Неправильный формат номера телефона',
});

export const notEmpty = (value, msg = 'Некорректно заполненное поле') => ({
  status: value && value.length > 0 ? 'ok' : 'fail',
  msg,
});

export const email = (value) => ({
  // form emailregex.com
  // eslint-disable-next-line
    status: /^[-a-z0-9~!$%^&*_=+}{\'?]+(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.(aero|arpa|biz|com|coop|edu|gov|info|int|mil|museum|name|net|org|pro|travel|mobi|[a-z][a-z])|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/i.test(value)
    ? 'ok' : 'fail',
  msg: 'Неправильный формат почты',
});

export const emailMayBeEmpty = (value) => {
  if (!value) {
    return {
      status: 'ok',
      msg: '',
    };
  }

  return email(value);
};

export const validateCellPhone = (value) => /\+7 \d{3} \d{3}-\d{2}-\d{2}/.test(value);

export const maskPhoneNumber = (number) => {
  if (typeof number === 'string') {
    const cellNumber = number.match(/(\d{3})(\d{3})(\d{2})(\d{2})/) || [];
    return `+7 ${cellNumber[1]} ${cellNumber[2]}-${cellNumber[3]}-${cellNumber[4]}`;
  }
  return number;
};
